import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
import { mapState } from 'vuex';
import customColorMixin from '@/mixins/customColor';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
export default {
  name: 'CoreVirtualDevicePacketViewer',
  mixins: [customColorMixin],
  props: {
    height: {
      type: Number,
      default: 300,
      required: false
    },
    headline: {
      type: String,
      required: false,
      default: null
    },
    bridgeManifest: {
      type: Object,
      required: false,
      default: null
    },
    valuePath: {
      type: String,
      required: true
    },
    packetHistory: {
      type: Array,
      required: true
    },
    dataIsLoading: {
      type: Boolean,
      required: false
    },
    loadingError: {
      type: String,
      required: false,
      default: null
    },
    loadingDone: {
      type: Boolean,
      required: false
    },
    showLoadMore: {
      type: Boolean,
      required: false
    },
    isLiveViewer: {
      type: Boolean,
      required: true
    },
    noPacketLabel: {
      type: String,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      scrolledDown: false,
      update: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions', 'language'])), {}, {
    hasNoPackets: function hasNoPackets() {
      return !this.dataIsLoading && this.packetHistory.length === 0 && this.loadingDone;
    },
    colNumber: function colNumber() {
      var baseCol = 3;
      var hasExternalId = get(this.packetHistory, '[0].externalId') !== undefined;
      var hasFrameCounter = get(this.bridgeManifest, 'virtualDevice.deviceTypes.packetParser.valueMapping.frameCounter');
      var hasPortManifest = get(this.bridgeManifest, 'virtualDevice.deviceTypes.packetParser.valueMapping.port');
      var hasPortPackets = get(this.packetHistory[0], "value.".concat(hasPortManifest));
      var metaDataLength = (get(this.bridgeManifest, 'virtualDevice.metaData') || []).length;
      return baseCol + (hasExternalId ? 1 : 0) + (hasFrameCounter ? 1 : 0) + (hasPortManifest && hasPortPackets ? 1 : 0) + metaDataLength;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$refs['outer-card'].$el.addEventListener('scroll', _this.debouncedScrollCalc);
    });
  },
  methods: {
    get: get,
    clickRowHandler: function clickRowHandler(item) {
      this.$emit('click', item);
    },
    debouncedScrollCalc: debounce(function () {
      var el = this.$refs['top-element'];
      var holder = this.$refs['outer-container'];

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          height = _el$getBoundingClient.height;

      var holderRect = holder.getBoundingClientRect();
      var isVisible = top <= holderRect.top ? holderRect.top - top <= height : bottom - holderRect.bottom <= height;
      this.scrolledDown = !isVisible;
    }, 250),
    localizeDate: function localizeDate(a) {
      if (a) {
        moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
        return moment(a).format('L LTS');
      }

      return '-';
    }
  }
};